import React from 'react'
import { isMockApi } from './isMockApi'

const bannerStyle = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2000,
  background: '#09cc7c',
  color: '#002d72',
  fontSize: 13,
  fontWeight: 700,
  textAlign: 'center',
  padding: '8px 12px',
  fontFamily: 'Roboto, sans-serif',
}

export default function MockApiBanner() {
  if (!isMockApi()) return null

  return (
    <div role="status" style={bannerStyle}>
      Front-only: sem API. Dados mockados para validar o frontend.
    </div>
  )
}
